import { FC, SyntheticEvent } from 'react';
import { Box, Indicator } from '@mantine/core';
import { useStyles } from './styles';
import { IUserTableData } from '@/entities/admin-app/users';
import { getIndicatorByUserStatus } from '@/containers/pages/users/utils';
import { UserStatusEnum } from '@/types/enums/user';
import OverflowTip from '@/components/OverflowTip';
import { useTranslation } from 'react-i18next';
import { IconX } from '@tabler/icons';
import { UserAvatarWithCard } from '@/components/user-avatar-with-card';

interface IUserListItemProps {
  item: IUserTableData;
  userId?: number;
  handleClick: (event: SyntheticEvent<HTMLDivElement>) => void;
  checkedUsers?: number[];
  multiple?: boolean;
  usersList?: IUserTableData[];
}

export const UserListItem: FC<IUserListItemProps> = ({
  item,
  handleClick,
  userId,
  checkedUsers,
  multiple,
  usersList
}) => {
  const { t } = useTranslation();
  const { classes, cx } = useStyles();
  const { color } = getIndicatorByUserStatus(item.Status, t);

  const isDisabled = usersList?.some((user) => user.Id === item.Id);

  return (
    <Box
      data-id={item.Id}
      className={cx(
        classes.user,
        {
          [classes.selectedUser]:
            (userId === item.Id && !multiple) || (multiple && checkedUsers?.includes(item.Id))
        },
        { [classes.disabledUser]: isDisabled && multiple }
      )}
      onClick={!isDisabled ? handleClick : undefined}
    >
      <Indicator
        label={item?.Status === UserStatusEnum.Ban ? <IconX size="8" stroke="4" /> : ''}
        size={item?.Status === UserStatusEnum.Ban ? 15 : 0}
        offset={6}
        position="bottom-start"
        color={color}
        zIndex={100}
      >
        <UserAvatarWithCard
          size={40}
          src={item.Avatar}
          user={item}
          hoverCardProps={{ zIndex: 3000 }}
        />
      </Indicator>
      <Box className={classes.content}>
        <OverflowTip size="sm" fw={400}>
          {`${item.Surname} ${item.FirstName || ''}`}
        </OverflowTip>

        <OverflowTip color="dimmed" size="xs">
          {item.Email}
        </OverflowTip>
      </Box>
    </Box>
  );
};
